import { render, staticRenderFns } from "./TestAdd.vue?vue&type=template&id=3888dc80&scoped=true&"
import script from "./TestAdd.vue?vue&type=script&lang=js&"
export * from "./TestAdd.vue?vue&type=script&lang=js&"
import style0 from "./TestAdd.vue?vue&type=style&index=0&id=3888dc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888dc80",
  null
  
)

export default component.exports